import { gql } from '@apollo/client'
export const getParentDetail = gql`
  query ParentDetail($id: ID!) {
    parentDetail(id: $id) {
      parent_id
      notes
      observers {
        user_id
        parent_id
        student_id
        notes
        user {
          first_name
          last_name
        }
      }
      students {
        student_id
        parent_id
        grade_level
        special_ed
        teacher_notes
        diploma_seeking
        testing_preference
        admin_notes
        applications {
          application_id
          status
        }
        status {
          student_id
          school_year_id
          status
          date_updated
        }
        grade_levels {
          grade_level
          school_year_id
        }
        person {
          person_id
          email
          first_name
          last_name
          middle_name
          preferred_first_name
          preferred_last_name
          uniqueId
          gender
          date_of_birth
          user_id
          user {
            user_id
          }
          address {
            address_id
            street
            street2
            state
            zip
            city
            county_id
          }
        }
        current_school_year_status {
          school_year_id
        }
      }
      phone {
        person_id
        phone_id
        name
        ext
        number
        recieve_text
      }
      person {
        person_id
        email
        first_name
        last_name
        middle_name
        preferred_first_name
        preferred_last_name
        gender
        uniqueId
        date_of_birth
        user {
          user_id
          userRegions {
            regionDetail {
              name
            }
          }
        }
        address {
          address_id
          street
          street2
          state
          zip
          city
          county_id
          school_district
          school_district_code
        }
      }
    }
  }
`

export const updatePersonAddressMutation = gql`
  mutation UpdatePersonAddress($updatePersonAddressInput: UpdatePersonAddressInput!) {
    updatePersonAddress(updatePersonAddressInput: $updatePersonAddressInput) {
      person_id
    }
  }
`

export const updateStudentsAddressMutation = gql`
  mutation UpdateStudentsAddress($updateStudentsAddressInput: UpdateStudentsAddressInput!) {
    updateStudentsAddress(updateStudentsAddressInput: $updateStudentsAddressInput) {
      parent_id
    }
  }
`

export const getStudentDetail = gql`
  query student($student_id: ID!) {
    student(student_id: $student_id) {
      student_id
      special_ed
      diploma_seeking
      reenrolled
      teacher_notes
      testing_preference
      grade_levels {
        grade_level
        school_year_id
        student_id
        school_year {
          school_year_id
          date_begin
        }
      }
      currentSoe {
        school_partner_id
        school_year_id
        partner {
          name
          abbreviation
        }
      }
      packets {
        student_id
        packet_id
        status
        deadline
        date_submitted
        date_accepted
        date_last_submitted
        special_ed
        school_district
        school_year_id
      }
      status {
        student_id
        school_year_id
        status
        date_updated
      }
      status_history {
        student_id
        school_year_id
        status
        date_updated
      }
      person {
        person_id
        email
        first_name
        last_name
        uniqueId
        middle_name
        preferred_first_name
        preferred_last_name
        gender
        date_of_birth
        address {
          address_id
          street
          street2
          state
          zip
          city
          county_id
          school_district
        }
        phone {
          person_id
          phone_id
          name
          ext
          number
        }
      }
      applications {
        application_id
        date_submitted
        date_accepted
        status
        school_year_id
        status
        midyear_application
        school_year {
          date_begin
          date_end
          midyear_application_open
          midyear_application_close
          RegionId
        }
      }
      current_school_year_status {
        application_id
        school_year_id
        special_ed_options
        date_begin
        date_end
      }
      parent {
        person {
          first_name
          last_name
          email
        }
      }
    }
    student_school_year(student_id: $student_id) {
      school_year_id
      date_begin
      date_end
      midyear_application_open
      midyear_application_close
      RegionId
      special_ed
      special_ed_options
      diploma_seeking
      grades
    }
  }
`

export const CreateObserMutation = gql`
  mutation CreateObserver($observerInput: ObserverInput!) {
    createObserver(observerInput: $observerInput) {
      user_id
    }
  }
`
export const UpdateStudentMutation = gql`
  mutation UpdateStudent($updateStudentInput: UpdateStudentInput!) {
    updateStudent(updateStudentInput: $updateStudentInput)
  }
`

export const DeleteWithdrawal = gql`
  mutation DeleteWithdrawal($activeOption: Int!, $studentId: Int!, $schoolYearId: Int!) {
    deleteWithdrawal(active_option: $activeOption, student_id: $studentId, school_year_id: $schoolYearId)
  }
`

export const sendInactiveStatusEmail = gql`
  mutation SendInactiveStatusEmail($studentId: Int!, $schoolYearId: Int!) {
    sendInactiveStatusEmail(student_id: $studentId, school_year_id: $schoolYearId)
  }
`
export const getSchoolYearsByRegionId = gql`
  query Region($regionId: ID!) {
    region(id: $regionId) {
      SchoolYears {
        school_year_id
        date_begin
        date_end
        grades
        birth_date_cut
        special_ed
        special_ed_options
        enrollment_packet
        midyear_application
        midyear_application_close
        midyear_application_open
        midyear_schedule_open
        midyear_schedule_close
      }
    }
  }
`

export const getCountiesByRegionId = gql`
  query getCounties($regionId: ID!) {
    getCounties(id: $regionId) {
      id
      county_name
    }
  }
`

export const getSchoolDistrictsByRegionId = gql`
  query SchoolDistrict($regionId: ID!) {
    schoolDistrict(id: $regionId) {
      id
      school_district_code
      school_district_name
      Region_id
    }
  }
`
export const getScheduleByStudentIdAndYearId = gql`
  query ScheduleByStudentAndYear($studentId: Int, $yearId: Int) {
    scheduleByStudentAndYear(studentId: $studentId, yearId: $yearId) {
      status
      schedule_id
      last_modified
      is_second_semester
      date_submitted
      date_accepted
      current_submission
      StudentId
    }
  }
`

export const getScheduleByStudentId = gql`
  query ScheduleByStudentId($studentId: Int!) {
    scheduleByStudentId(studentId: $studentId) {
      status
      schedule_id
      last_modified
      is_second_semester
      date_submitted
      date_accepted
      current_submission
      StudentId
      SchoolYearId
    }
  }
`

export const getStatusesByStudent = gql`
  query getStatusesByStudent($studentId: Float!) {
    getStatusesByStudent(student_id: $studentId) {
      status
      school_year_id
      student_id
    }
  }
`
